export default __webpack_public_path__ + "static/media/shoe4.ad0d6ea9.jpg";